import { create } from "zustand";
import { IDLE_TIMEOUT } from "../constants/Common";

const removeEquipmentStore = create((set, get) => ({
  rmEquipment: {},  // Lưu trữ bản đồ của từng player
  timeouts: {}, // Lưu timeout của từng player để hủy nếu có cập nhật mới

  setRmEquipment: (playerId, rmEquip) => {
    set((state) => ({
      rmEquipment: {
        ...state.rmEquipment,
        [playerId]: rmEquip,
      },
    }));

    // Nếu đã có timeout, clear nó trước
    if (get().timeouts[playerId]) {
      clearTimeout(get().timeouts[playerId]);
    }

    // Đặt timeout để xóa playerId sau 15 giây nếu không có cập nhật mới
    const timeoutId = setTimeout(() => {
      set((state) => {
        const rmEquip = { ...state.rmEquipment };
        delete rmEquip[playerId];
        return { rmEquipment: rmEquip };
      });

      // Xóa timeout khỏi danh sách
      set((state) => {
        const newTimeouts = { ...state.timeouts };
        delete newTimeouts[playerId];
        return { timeouts: newTimeouts };
      });
    }, IDLE_TIMEOUT.CLEAR_STATUS_SELL_EQUIPMENT);

    // Cập nhật danh sách timeout
    set((state) => ({
      timeouts: {
        ...state.timeouts,
        [playerId]: timeoutId,
      },
    }));
  },
}));

export default removeEquipmentStore;
